import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {
  Box,
  Dialog,
  Typography,
  styled,
  Stack,
  Divider,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Alert, Toast } from 'app/components';
import { setMilestones } from 'app/store/features/chartsSlice';
import { ColorsV2 } from 'app/constants/color';
import apiService from 'app/services/apiService';
import { parseAndFormatDate } from 'app/utils';

export default function ModelForm({
  fetchedMultipleMilestoneData,
  setFetchedMultipleMilestoneData,
  setIsMultipleMilestoneModelOpen,
  setIsMilestoneModelOpen,
  setMultipleMilestoneData,
}) {
  const dispatch = useDispatch();

  const milestoneData = useSelector(state => state.charts.milestones);
  const handleClose = () => {
    setFetchedMultipleMilestoneData([]);
    setIsMultipleMilestoneModelOpen(false);
  };
  const [milseStoneId, setMileStoneID] = useState('');
  const [openConfirmation, setOpeConfirmation] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const deleteMilestone = async () => {
    setOpeConfirmation(false);
    try {
      await apiService.deleteMilestone(milseStoneId);
      const filtered = fetchedMultipleMilestoneData?.filter(item => item.id !== milseStoneId);
      setFetchedMultipleMilestoneData(filtered);
      const filtered2 = milestoneData.filter(item => item.id !== milseStoneId);
      dispatch(setMilestones(filtered2));
      setShowToast(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = data => {
    setMultipleMilestoneData(prev => [...prev, { ...data }]);
    setIsMultipleMilestoneModelOpen(false);
    setIsMilestoneModelOpen(true);
  };

  const CustomMultipleTooltipData = styled(Typography)({
    fontFamily: 'DM Sans, sans-serif',
    margin: '0px 5px 0px 0px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '21px',
    color: 'black',
  });

  function compareDates(arr) {
    const firstDate = arr[0]?.date;

    for (let i = 1; i < arr?.length; i++) {
      if (arr[i]?.date !== firstDate) {
        return false;
      }
    }
    return true;
  }
  const bool = compareDates(fetchedMultipleMilestoneData);
  const { t } = useTranslation('translation', { keyPrefix: 'identify_headings' });

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <Box
          sx={{
            background: ColorsV2.primary,
            width: '600px',
            padding: '10px 30px 30px 30px',
            boxSizing: 'border-box',
          }}
        >
          <DialogTitle sx={{ color: ColorsV2.white }}>
            {bool
              ? `${t('MilestonesFor')} ${parseAndFormatDate(fetchedMultipleMilestoneData[0]?.date)}`
              : t('OverlappingMilestones')}
          </DialogTitle>{' '}
          {fetchedMultipleMilestoneData.map(item => (
            <>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '50px',
                  marginBottom: '10px',
                }}
                key={item.id}
              >
                <Stack>
                  <CustomMultipleTooltipData>
                    <Stack direction='row' spacing={2}>
                      <Typography
                        sx={{
                          color: ColorsV2.white,
                          fontFamily: 'DM Sans, sans-serif',
                          fontSize: '14px',
                        }}
                      >
                        {t('Date')}:
                      </Typography>
                      <Typography
                        sx={{
                          color: ColorsV2.white,
                          fontSize: '14px',
                        }}
                      >
                        {parseAndFormatDate(item.date)}
                      </Typography>
                    </Stack>
                  </CustomMultipleTooltipData>
                  <CustomMultipleTooltipData>
                    <Stack direction='row' spacing={2}>
                      <Typography
                        sx={{
                          color: ColorsV2.white,
                          fontFamily: 'DM Sans, sans-serif',
                          fontSize: '14px',
                        }}
                      >
                        {t('Name')}:
                      </Typography>
                      <Typography
                        sx={{
                          color: ColorsV2.white,
                          fontSize: '14px',
                        }}
                      >
                        {item.name}
                      </Typography>
                    </Stack>
                  </CustomMultipleTooltipData>
                  <CustomMultipleTooltipData>
                    <Stack direction='row' spacing={2}>
                      <Typography
                        sx={{
                          color: ColorsV2.white,
                          fontFamily: 'DM Sans, sans-serif',
                          fontSize: '14px',
                        }}
                      >
                        {t('Description')}:
                      </Typography>
                      <Typography
                        sx={{
                          color: ColorsV2.white,
                          fontSize: '14px',
                        }}
                      >
                        {item.description}
                      </Typography>
                    </Stack>
                  </CustomMultipleTooltipData>
                </Stack>
                <Stack
                  direction='row'
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginLeft: '-50px',
                  }}
                >
                  <IconButton
                    style={{
                      width: '80%',
                    }}
                    onClick={() => handleEdit(item)}
                  >
                    <EditOutlinedIcon sx={{ color: ColorsV2.white }} />
                  </IconButton>
                  <IconButton
                    style={{
                      width: '80%',
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      setMileStoneID(item.id);
                      setOpeConfirmation(true);
                    }}
                  >
                    <svg
                      width='20'
                      height='20'
                      viewBox='0 0 20 20'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M8.25092 6.15227e-05C8.13012 -0.00148559 8.01074 0.0261671 7.90292 0.0806673C7.79511 0.135167 7.70205 0.214902 7.63167 0.31309C7.56129 0.411277 7.51567 0.525011 7.49869 0.644617C7.4817 0.764223 7.49386 0.886162 7.53412 1.00006H5.32123C4.4026 1.00006 3.54238 1.45979 3.03314 2.22467L1.84955 4.00006H1.75092C1.65153 3.99866 1.55286 4.01702 1.46063 4.05408C1.36841 4.09114 1.28447 4.14616 1.21369 4.21594C1.14291 4.28572 1.08671 4.36888 1.04835 4.46057C1.00999 4.55227 0.990234 4.65067 0.990234 4.75006C0.990234 4.84946 1.00999 4.94786 1.04835 5.03955C1.08671 5.13124 1.14291 5.2144 1.21369 5.28418C1.28447 5.35396 1.36841 5.40899 1.46063 5.44605C1.55286 5.48311 1.65153 5.50147 1.75092 5.50006H2.13275C2.19709 5.50979 2.26241 5.5111 2.32709 5.50397L3.56342 17.043C3.71259 18.4342 4.89883 19.5001 6.29779 19.5001H13.7031C15.102 19.5001 16.2883 18.4342 16.4374 17.043L17.6747 5.50397C17.7381 5.51076 17.8021 5.50945 17.8652 5.50006H18.2509C18.3503 5.50147 18.449 5.48311 18.5412 5.44605C18.6334 5.40899 18.7174 5.35396 18.7881 5.28418C18.8589 5.2144 18.9151 5.13124 18.9535 5.03955C18.9918 4.94786 19.0116 4.84946 19.0116 4.75006C19.0116 4.65067 18.9918 4.55227 18.9535 4.46057C18.9151 4.36888 18.8589 4.28572 18.7881 4.21594C18.7174 4.14616 18.6334 4.09114 18.5412 4.05408C18.449 4.01702 18.3503 3.99866 18.2509 4.00006H18.1523L16.9687 2.22467C16.459 1.4602 15.5989 1.00006 14.6806 1.00006H12.4677C12.508 0.886162 12.5201 0.764223 12.5031 0.644617C12.4862 0.525011 12.4405 0.411277 12.3702 0.31309C12.2998 0.214902 12.2067 0.135167 12.0989 0.0806673C11.9911 0.0261671 11.8717 -0.00148559 11.7509 6.15227e-05H8.25092ZM5.32123 2.50006H14.6806C15.0993 2.50006 15.4883 2.70817 15.7206 3.0567L16.3495 4.00006H3.65228L4.28119 3.0567C4.28152 3.05638 4.28184 3.05605 4.28217 3.05573C4.51391 2.70763 4.90186 2.50006 5.32123 2.50006ZM3.83588 5.50006H16.166L14.9462 16.8829C14.8774 17.5247 14.3481 18.0001 13.7031 18.0001H6.29779C5.65275 18.0001 5.12443 17.5247 5.0556 16.8829L3.83588 5.50006Z'
                        fill={ColorsV2.white}
                      />
                    </svg>
                  </IconButton>
                </Stack>
              </Box>
              <Divider
                sx={{
                  background: 'lightGrey',
                  width: '100%',
                  height: '1px',
                  marginBottom: '10px',
                }}
              />
            </>
          ))}
        </Box>
      </Dialog>
      <Toast
        open={showToast}
        setOpen={setShowToast}
        message={t('milestone_deleted')}
        severity='success'
      />

      <Alert
        open={openConfirmation}
        title={t('DeleteMilestone')}
        text={t('DeleteMilestoneText')}
        setOpen={setOpeConfirmation}
        handleConfirmation={deleteMilestone}
      />
    </>
  );
}
